import React from "react"
import { Headline, CTA, GridLines } from "@shared"
import { css } from "@jsUtils"
import { CONTENT } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./joinUs.module.scss"

const { CAREERS } = CONTENT
const { JOINUS } = CAREERS
const { cta, headline1, headline2 } = JOINUS
/**
 * Join Us section
 * @param {object} props - React props
 */
const JoinUs = props => {
  const { color, theme } = props
  const [ready, setReady] = React.useState(false)
  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.content}>
        <Headline size={1} className={Styles.headline}>
          {headline1}
        </Headline>
        <Headline size={5} className={Styles.subhead}>
          {headline2}
        </Headline>
        <CTA
          ascope="CTAS"
          adata="MISC.JOINUS"
          ready={ready}
          className={Styles.cta}
          to="https://boards.greenhouse.io/exo"
          color={color}
          target="_blank"
          rel="noopener noreferrer"
          anchor
        >
          {cta}
        </CTA>
      </div>
    </PageSection>
  )
}

export default JoinUs
